<ui-results-item [ergebnis]="ergebnis()" [icon]="icon()">
  @if (!ungrouped()) {
    <ng-container left-side>
      <div class="flex flex-wrap mt-2 md:mt-4 gap-2">
        @for (item of ergebnis().details.kombinationRelation; track item.kombinationsId) {
          <div
            class="bg-cp-primary-8 px-4 py-1 text-xs font-bold rounded-2xl flex items-center gap-1 cursor-pointer"
            [ngClass]="{
              'bg-cp-primary-8': !item.isParent,
              'bg-cp-primary-100 text-white': item.isParent,
            }"
            (click)="toggleBausteine(item)"
          >
            <div>{{ item.name }} {{ item.preisDifferenz | currency }}</div>
            @if (!item.isParent) {
              <mat-icon svgIcon="cp-add" class="!w-3 !h-3 !white-icon" />
            } @else {
              <mat-icon svgIcon="cp-remove" class="!w-3 !h-3" />
            }
          </div>
        }
      </div>
    </ng-container>
  }

  <ng-container right-side>
    <div class="flex flex-wrap flex-row-reverse gap-4 md:gap-8">
      <div>
        <!-- Deliberately not a MatButton: .btn-weiter is the outlined pill from the design. -->
        <button class="btn-weiter px-6 py-2 font-bold" (click)="selected.emit(asMarkedItem())">
          Weiter
        </button>
      </div>

      <div>
        <div class="text-sm">{{ beitragCaption() }}</div>
        <div class="font-grotesk-h6">
          {{ ergebnis().bruttoBetrag | currency }}
        </div>

        @if (isBest()) {
          <span
            class="best-badge inline-flex items-center justify-center bg-[#4E997E] text-white text-xs font-semibold leading-[14px] h-6 px-3 md:px-4 rounded-full mt-1 whitespace-nowrap"
          >
            Preis-/Leistungssieger
          </span>
        }

        @if (ergebnis().rating.wert > 0) {
          <ui-rating-tooltip class="mt-2 block" [ratingWert]="ergebnis().rating.wert">
            <ui-star-rating [value]="ergebnis().rating.wert" />
          </ui-rating-tooltip>
        }
      </div>
    </div>
  </ng-container>

  <ng-container actions>
    <div class="mt-2">
      <mat-checkbox [checked]="checked()" [disabled]="compareDisabled()" (change)="toggleCompare()"
        >Tarif vergleichen</mat-checkbox
      >

      <div class="flex items-center justify-end">
        <button
          mat-button
          color="primary"
          class="grid gap-4 grid-flow-col"
          (click)="detailsOpen.set(!detailsOpen())"
        >
          Details
          <mat-icon
            iconPositionEnd
            svgIcon="cp-direction-down"
            class="transition-transform duration-300"
            [class.rotate-180]="detailsOpen()"
          />
        </button>
      </div>

      @if (detailsOpen() && itemDetails(); as slot) {
        <ng-container *ngTemplateOutlet="slot; context: { $implicit: ergebnis() }" />
      }

      @if (detailsOpen() && enableTestDataViewer) {
        <div class="flex gap-2 border-t mt-8 pt-4 text-sm">
          <mat-icon
            class="cursor-pointer shrink-0 transition-transform duration-300"
            svgIcon="cp-direction-down"
            [class.-rotate-90]="!jsonExpand()"
            (click)="jsonExpand.set(!jsonExpand())"
          />
          <div class="overflow-x-auto">
            @if (jsonExpand()) {
              <pre>{{ ergebnis() | json }}</pre>
            } @else {
              <pre>{{ '{ ... }' }}</pre>
            }
          </div>
        </div>
      }
    </div>
  </ng-container>
</ui-results-item>

@if (!ungrouped()) {
  <div class="mt-6 flex flex-col space-y-4">
    @for (child of children(); track child.berechnungId + child.kombinationId) {
      <ui-results-item-success
        @slideDownUp
        [ergebnis]="child"
        [icon]="icon()"
        [itemDetails]="itemDetails()"
        (selected)="selected.emit($event)"
      />
    }
  </div>
}
